import styled from "styled-components";
import { Typography } from "@mui/material";

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: var(--mui-palette-background-default);
  box-sizing: border-box;
  overflow: hidden;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid var(--mui-palette-divider);
  background-color: var(--mui-palette-background-paper);
  border-radius: 8px 8px 0 0;
  margin-bottom: 0;
`;

export const ContentContainer = styled.div`
  flex: 1;
  padding: 24px;
  overflow-y: auto;
  background-color: var(--mui-palette-background-paper);
  border-radius: 0 0 8px 8px;
  box-shadow: var(--mui-shadows-2);

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(99, 96, 150, 0.7);
    border-radius: 5px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
`;

export const Title = styled(Typography)`
  color: var(--mui-palette-text-primary);
  margin: 0;
`;

export const TopBtnBox = styled.div`
  display: flex;
  gap: 0.5rem;
`;

